<template>
    <div id="app">
        <vue-html2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="false"
                :paginate-elements-by-height="2900"
                filename="swot_analysis"
                :pdf-quality="2"
                :manual-pagination="false"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="800px"
                @hasDownloaded="sendEmail"
                ref="html2Pdf"
        >
            <section slot="pdf-content">
                <div id="pdf">
                    <div class="row">
                        <div class="col-md-3 text-right logo hidden-large">
                            <div v-if="!url" class="example-1">
                                <div class="form-group">
                                    <label class="label">
                                        <i class="material-icons">attach_file</i>
                                        <span class="title">Choose Logo</span>
                                        <input type="file" @change="onFileChange" />
                                    </label>
                                </div>
                            </div>
                            <img style="max-width: 100%" :src="url" alt="">
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-3 font-weight-bold font-20 text-gray m-t-10">Department:</div>
                                <div class="col-md-9 m-t-10"><input placeholder="Enter department" class="jd_input" type="text" v-model="department"></div>
                                <div class="col-md-3 font-weight-bold font-20 text-gray m-t-10">Title:</div>
                                <div class="col-md-9 m-t-10"><input placeholder="Enter title" class="jd_input" type="text" v-model="title"></div>
                                <div class="col-md-3 m-t-10 font-weight-bold font-20 text-gray">Reports to:</div>
                                <div class="col-md-9 m-t-10"><input placeholder="Enter report to" class="jd_input" type="text" v-model="reports_to"></div>
                                <div class="col-md-3 m-t-10 font-weight-bold font-20 text-gray">Person:</div>
                                <div class="col-md-9 m-t-10"><input placeholder="Enter person" class="jd_input" type="text" v-model="person"></div>
                            </div>
                        </div>
                        <div class="col-md-3  col-sm-12 text-right logo  hidden-mobile">
                            <div v-if="!url" class="example-1">
                                <div class="form-group">
                                    <label class="label">
                                        <i class="material-icons">attach_file</i>
                                        <span class="title">Choose Logo</span>
                                        <input type="file" @change="onFileChange" />
                                    </label>
                                </div>
                            </div>
                            <img style="max-width: 100%" :src="url" alt="">
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-12">
                            <h5>Department vision & role</h5>
                            <div class="form-group row">
                                <label class="col-md-5">What is your long-term vision for your company?</label>
                                <div class="answer col-md-7">{{m1}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">How does this person contribute to that vision?</label>
                                <div class="answer col-md-7">{{m2}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">What type of attitude do you expect to see from someone in this position?</label>
                                <div class="answer col-md-7">{{m3}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">How does this person influence the company’s reputation in the industry?</label>
                                <div class="answer col-md-7">{{m4}}</div>
                            </div>
                            <h5>Position Description</h5>
                            <div class="form-group row">
                                <label class="col-md-5">How do you see this team member impacting the rest of the team?</label>
                                <div class="answer">{{l1}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">In what areas should this employee take the lead?</label>
                                <div class="answer">{{l2}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">How does someone in this position fill talent gaps in your team?</label>
                                <div class="answer">{{l3}}</div>
                            </div>
                            <div class="html2pdf__page-break"></div>
                            <h5>Major Functions</h5>
                            <div class="form-group row">
                                <label class="col-md-5">What is this person’s overall function in your company?</label>
                                <div class="answer">{{t1}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">What specific tasks should this person be able to do exceptionally well?</label>
                                <div class="answer">{{t2}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">What outcomes should this employee achieve?</label>
                                <div class="answer">{{t3}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">What does it mean for an individual to succeed in this position?</label>
                                <div class="answer">{{t4}}</div>
                            </div>
                            <h5>Metrics</h5>
                            <div class="form-group row">
                                <label class="col-md-5">What does it mean for an individual to succeed in this position?</label>
                                <div class="answer">{{a1}}</div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-5">What key metrics will you use to measure this team member’s success?</label>
                                <div class="answer">{{a2}}</div>
                            </div>
                            <div class="text-center">
                                <a href="https://getoutofthetruck.life">getoutofthetruck.life (c) 2021</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </vue-html2pdf>
        <div class="row">
            <div class="col-md-3  col-sm-12 text-right logo hidden-large">
                <div v-if="!url" class="example-1">
                    <div class="form-group">
                        <label class="label">
                            <i class="material-icons">attach_file</i>
                            <span class="title">Choose Logo</span>
                            <input type="file" @change="onFileChange" />
                        </label>
                    </div>
                </div>
                <img style="max-width: 100%" :src="url" alt="">
            </div>
            <div class="col-md-9 col-sm-12 ">
                <div class="row">
                    <div class="col-md-3 col-sm-12 font-weight-bold font-20 text-gray m-t-10">Department:</div>
                    <div class="col-md-9 col-sm-12 m-t-10"><input placeholder="Enter department" class="jd_input" type="text" v-model="department"></div>
                    <div class="col-md-3 col-sm-12 font-weight-bold font-20 text-gray m-t-10">Title:</div>
                    <div class="col-md-9 col-sm-12 m-t-10"><input placeholder="Enter title" class="jd_input" type="text" v-model="title"></div>
                    <div class="col-md-3 col-sm-12 m-t-10 font-weight-bold font-20 text-gray">Reports to:</div>
                    <div class="col-md-9 col-sm-1 m-t-10"><input placeholder="Enter report to" class="jd_input" type="text" v-model="reports_to"></div>
                    <div class="col-md-3 col-sm-12 m-t-10 font-weight-bold font-20 text-gray">Person:</div>
                    <div class="col-md-9 col-sm-12 m-t-10"><input placeholder="Enter person" class="jd_input" type="text" v-model="person"></div>
                </div>
            </div>
            <div class="col-md-3  col-sm-12 text-right logo  hidden-mobile">
                <div v-if="!url" class="example-1">
                    <div class="form-group">
                        <label class="label">
                            <i class="material-icons">attach_file</i>
                            <span class="title">Choose Logo</span>
                            <input type="file" @change="onFileChange" />
                        </label>
                    </div>
                </div>
                <img style="max-width: 100%" :src="url" alt="">
            </div>

        </div>
        <div class="row">
            <div class="col-12">
                <h5>Department vision & role</h5>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What is your long-term vision for your company?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="m1"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">How does this person contribute to that vision?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="m2"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What type of attitude do you expect to see from someone in this position?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="m3"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">How does this person influence the company’s reputation in the industry?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="m4"></textarea>
                </div>
                <h5>Position Description</h5>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">How do you see this team member impacting the rest of the team?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="l1"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">In what areas should this employee take the lead?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="l2"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">How does someone in this position fill talent gaps in your team?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="l3"></textarea>
                </div>
                <h5>Major Functions</h5>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What is this person’s overall function in your company?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="t1"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What specific tasks should this person be able to do exceptionally well?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="t2"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What outcomes should this employee achieve?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="t3"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What does it mean for an individual to succeed in this position?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="t4"></textarea>
                </div>
                <h5>Metrics</h5>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What does it mean for an individual to succeed in this position?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="a1"></textarea>
                </div>
                <div class="form-group row">
                    <label class="col-md-5 col-sm-12">What key metrics will you use to measure this team member’s success?</label>
                    <textarea class="col-md-7 col-sm-12"  type="text" v-model="a2"></textarea>
                </div>
            </div>
        </div>
        <footer class="jd_footer">
            <div class="row">
                <div class="col-md-12 footer-col-12">
                    <button class="btn btn-white btn-lg" type="button"  @click="window.print()">Print</button>
<!--                    <button class="btn btn-black  btn-lg float-right" type="button" @click="generateReport()">Download</button>-->
                    <button class="btn btn-black  btn-lg float-right" @click="generateReport()" type="button">Download</button>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

  import VueHtml2pdf from 'vue-html2pdf'
  import axios from 'axios'

  export default {
    name: 'App',
    components: {
      VueHtml2pdf,
    },
    data: () => ({
      window: window,
      url: null,
      department: '',
      title: '',
      reports_to: '',
      person: '',
      m1: '',
      m2: '',
      m3: '',
      m4: '',
      l1: '',
      l2: '',
      l3: '',
      t1: '',
      t2: '',
      t3: '',
      t4: '',
      a1: '',
      a2: '',
      a3: '',
    }),
    methods: {
      onFileChange(e) {
        const file = e.target.files[0];
        this.url = URL.createObjectURL(file);
      },
      generateReport() {
        window.scrollTo(0, 0);
        setTimeout(() => {
          this.$refs.html2Pdf.generatePdf();
        }, 1000)

      },
      sendEmail(e) {
        let reader = new FileReader();
        reader.readAsDataURL(e);
        reader.onloadend = function () {
          let base64data = reader.result;
          axios.post('https://911.gazingle.com/get_out_of_the_truck/jd', {
            file: base64data,
          })
            .then(() => {
            })
            .catch(() => {

            });
        }
      },
      blobToFile(theBlob, fileName) {
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
      },
    },
  }
</script>

<style scoped>
    .logo img{
        margin-right:20px;
    }
    .font-20{
        font-size:20px;
    }
    .text-gray{
        color:#666666
    }
    .m-t-10{
        margin-top:10px;
    }
    .jd_input{
        background: #fafafa;
        border:1px solid #D2D8E4;
        border-radius: 5px;
        padding:5px 10px;
        width:100%;
    }
    #app{
        padding-top:20px;
    }
    h5{
        font-size:36px;
        color:#3a3a3a;
        clear:both;
        margin-top:40px;
        margin-bottom:40px;
    }
    .form-group{
        clear:both;
        margin-bottom:20px;
    }
    .form-group:after{
        clear: both;
    }
    .form-group label{
        font-size:14px;
        /*height: 20px;*/
    }
    .form-group textarea{
        background: #fafafa;
        border:1px solid #D2D8E4;
        border-radius: 5px;
        padding:5px 10px;
        height:40px;
    }
    .btn-white{
        color:black;
        border:1px solid #3a3a3a;
        font-size:12px!important;
        text-transform: uppercase;
        width:140px;
    }
    .btn-black{
        color: white;
        background: #3a3a3a;
        border:1px solid black;
        font-size:12px!important;
        text-transform: uppercase;
        width:140px;
    }
    .footer-col-12{
        padding-right:0
    }
    .jd_footer{
        margin-top:30px;
        margin-bottom:30px;
    }
    .example-1 .form-group{padding:0em;margin:0em}
    .example-1 input[type=file]{outline:0;opacity:0;pointer-events:none;user-select:none}
    .example-1 .label{height:auto!important;border:2px dashed #D2D8E4;border-radius:5px;display:block;padding:1.2em;transition:border 300ms ease;cursor:pointer;text-align:center}
    .example-1 .label i{display:block;font-size:42px;padding-bottom:16px}
    .example-1 .label i,.example-1 .label .title{color:grey;transition:200ms color}
    .example-1 .label:hover{border:2px dashed #666666}
    .example-1 .label:hover i,.example-1 .label:hover .title{color:#666666}
    .hidden-large{
        display: none
    }
    .hidden-mobile{
        display: block
    }
    @media (max-width: 767px) {
        .hidden-large{
            display: block
        }
        .hidden-mobile{
            display: none
        }
    }
    .logo{
        margin-top: 10px;
    }
    #pdf{
        /*display:none;*/
        margin-right:40px;
        margin-left:20px;
        margin-top:40px;
    }
    #pdf .col-md-5{
        float:left;
        width: 41.66666%!important;
    }
    #pdf .col-md-7{
        float:left;
        width: 58.33333%!important;
    }
    #pdf .col-md-3{
        float:left;
        width: 25%!important;
    }
    #pdf .col-md-9{
        float:left;
        width: 75%;
    }
    .answer{
        background: #fafafa;
        border:1px solid #D2D8E4;
        border-radius: 5px;
        padding:5px 10px;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }
</style>
